import store from '~/store'


/**
 * 動的ページ
 */
import DestSingle from '~/router/destsingle';
import AccSingle from '~/router/accsingle';

/**
 * 静的ページ
 */
import Top from '~/router/top'
import About from '~/pages/about'
import Terms from '~/pages/terms'
import PrivacyPolicy from '~/pages/privacy_policy'
import NotFound from '~/pages/not_found'

// dummy
// import Top from '~/pages/top'
import pageDestTemplate from '~/pages/dest_template'
import pageAccTemplate from '~/pages/acc_template'



export default [
  DestSingle,
  AccSingle,
  Top,
  // {
  //   path: '/',
  //   name: 'top',
  //   component: Top
  // },
  {
    path: '/about/',
    name: 'about',
    component: About
  },
  {
    path: '/destination/',
    name: 'destination',
    component: DestSingle
  },
  {
    path: '/accommodation/',
    name: 'accommodation',
    component: AccSingle
  },
  {
    path: '/terms/',
    name: 'terms',
    component: Terms
  },
  {
    path: '/privacypolicy/',
    name: 'privacypolicy',
    component: PrivacyPolicy
  },
  // dummy
  // {
  //   path: '/dummy_destination/',
  //   name: 'destination',
  //   component: pageDestTemplate
  // },
  // {
  //   path: '/dummy_accommodation/',
  //   name: 'accommodation',
  //   component: pageAccTemplate
  // },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js